import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../security/AuthContext";
import { useEffect, useRef } from "react";

export const SideBar = ({showSidebar}) => {
  const { user } = useAuth();
  const asideRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    toggleSideBar()
  }, [showSidebar]);

  const toggleSideBar = () => {
    asideRef.current.classList.toggle('-translate-x-full');
  }

  const menu = [
    {url:"/messages", icon:"fa-paper-plane", label:"Threads"},
    {url:"/users", icon:"fa-user", label:"Users", roles:["admin"]},
    {url:"/config", icon:"fa-paper-plane", label:"Settings", roles:["admin"]},
  ];

  const hasAccess = (roles) => {
    return !roles || (user.roles && roles.some(i => user.roles.includes(i)));
  }

  const onItemClick = (item) => {
    toggleSideBar()
    navigate(item.url)
  }

  return (
    <aside ref={asideRef} 
      className={`bg-indigo-100 text-white w-48 fixed h-full pt-4 z-10 transform -translate-x-full md:translate-x-0 transition-transform duration-300 ease-in-out`}
    >
      <ul className="space-y-2">
          {menu.map(item => 
            <>
              {hasAccess(item.roles) && (
              <li>  
                <button
                  onClick={(e) => onItemClick(item)}
                  className="w-full text-left block text-gray-900 px-4 py-2 hover:bg-indigo-500 hover:text-white transition-colors"
                >
                  <i className={`fas ${item.icon} pr-2`}></i>
                  {item.label}
                </button>
              </li>  
              )}
            </>
          )}
      </ul>
    </aside>
  );
};
